import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {
    ActionsServiceModuleName,
    ActionStatusModuleName,
    AddressModuleName,
    AngularMaterialTableModuleName,
    EmployeeAutocompleteModuleName,
    NgMessagesModule,
    OpportunitiesModuleName,
    OpportunitiesServiceModuleName,
    OpportunityActionsModuleName,
    OpportunityFilterModuleName,
    SortablePaginationModuleName,
    UserServiceModuleName
} from "../utils/names/optionalModuleNames";
import {NavigationAccessRoles, NavigationItem} from "../main/model/navigationItem";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";
import {getTabName} from "modules/utils/TabNameUtils";

let template = require('./route/opportunities.html');

const OpportunitiesModuleConfiguration = new RestrictedRouteModuleConfiguration(
    UserGranredAuthorityName.OPPORTUNITIES,
    [
        OpportunitiesModuleName,
        OpportunitiesServiceModuleName,
        UserServiceModuleName,
        OpportunityFilterModuleName,
        OpportunityActionsModuleName,
        EmployeeAutocompleteModuleName,
        ActionsServiceModuleName,
        AngularJsMaterialModuleName,
        AngularMaterialTableModuleName,
        SortablePaginationModuleName,
        AddressModuleName,
        NgMessagesModule,
        ActionStatusModuleName
    ],
    [
        ["/", {
            template: template,
            controller: 'opportunitiesController'
        }],
        ["/opportunities", {
            template: template,
            controller: 'opportunitiesController'
        }]
    ],
    [
        new NavigationItem({
            active: true,
            title: "Opportunities",
            href: "#!opportunities",
            accessRole: [NavigationAccessRoles.ROLE_USER],
            activeFunction: (routeName) => routeName[1] === "" || routeName.indexOf('opportunities') !== -1
        })
    ],
    [OpportunitiesModuleName],
    [UserGranredAuthorityName.OPPORTUNITIES],
     getTabName() + ' | Opportunities'
);

export default OpportunitiesModuleConfiguration;